import { BaseIcon, BaseIconProps } from "./BaseIcon";

export function Vehicle2Icon(props: BaseIconProps) {
  return (
    <BaseIcon {...props}>
      <path
        fill="currentColor"
        d="M30.83 11.5a.78.78 0 0 0-.6-.28h-2.92C26.6 9.34 25.65 7.5 24.6 6.8c-3.7-2.4-13.48-2.4-17.18 0-1.06.7-2 2.54-2.72 4.42H1.77c-.23 0-.45.1-.6.28a.75.75 0 0 0-.15.63l.43 2.07c.07.36.39.61.75.61h.87a5.1 5.1 0 0 0-1.25 3.35 5 5 0 0 0 1.6 3.77l.04.03v2.9c0 .63.52 1.14 1.15 1.14h2.7c.63 0 1.15-.51 1.15-1.14v-1.17h15.08v1.17c0 .63.52 1.14 1.16 1.14h2.69c.63 0 1.15-.51 1.15-1.14v-2.84c1.1-1 1.63-2.38 1.64-3.75 0-1.25-.42-2.49-1.3-3.46h.92c.36 0 .68-.25.75-.6l.43-2.08a.76.76 0 0 0-.15-.63ZM8.68 8.7c2.94-1.91 11.7-1.91 14.64 0 .57.38 1.3 1.87 1.98 3.71H6.7c.67-1.84 1.4-3.33 1.98-3.7Zm-3.45 9.75A2.25 2.25 0 0 1 7.5 16.2c1.25 0 2.27 1 2.27 2.24a2.25 2.25 0 0 1-2.27 2.24c-1.25 0-2.27-1-2.27-2.24Zm19.3 2.24c-1.25 0-2.27-1-2.27-2.24a2.25 2.25 0 0 1 2.27-2.24c1.25 0 2.27 1 2.27 2.24a2.25 2.25 0 0 1-2.27 2.24Z"
      />
    </BaseIcon>
  );
}
